export default "img"